import script from "./TokenListCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenListCard.vue?vue&type=script&setup=true&lang=ts"

import "./TokenListCard.vue?vue&type=style&index=0&id=afc09180&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afc09180"]])

export default __exports__